import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { PAGE_SELECTION_TYPE_NONE } from "%/dynamic-component-editor/constants/click-action-constants";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import LinkType from "%/dynamic-component-editor/options/link-type";

export default class HrefAction extends BaseOption {
  static userInterfaceComponent = {
    label: "Click Action",
    component: inspectorTools.CLICK_ACTION,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useCustomLabelWhenVariableLinked: true,
  };

  static defaultValue = {
    action: "goToUrl",
    label: "",
    modal: "",
    linkType: LinkType.LINK_TYPE_HYPERLINK,
    page: "",
    pageSelectionType: PAGE_SELECTION_TYPE_NONE,
    value: "",
    openInNewTab: false,
    hasUpdated: false,
  };

  static getModifiedRawValue(option, optionValues, state) {
    if (option.hasUpdated) {
      return {
        ...this.defaultValue,
        ...option,
      };
    }

    let openInNewTab = optionValues[`${state}.open-in-new-tab`] === "true";

    return {
      action: optionValues[`${state}.button-action`] ?? "goToUrl",
      label: optionValues[`${state}.label`] ?? "",
      modal: optionValues[`${state}.modal`] ?? "",
      linkType: optionValues[`${state}.link-type`] ?? LinkType.LINK_TYPE_HYPERLINK,
      value: optionValues[`${state}.href-option`] ?? "",
      openInNewTab: openInNewTab,
      hasUpdated: false,
      page: "",
      pageSelectionType: PAGE_SELECTION_TYPE_NONE,
    };
  }

  // eslint-disable-next-line
  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit", optionValues = {}) {
    if (configValue.hasUpdated) {
      return {
        ...this.defaultValue,
        ...configValue,
      };
    }

    return {
      action: optionValues["default.button-action"] ?? "goToUrl",
      label: optionValues["default.label"] ?? "",
      modal: optionValues["default.modal"] ?? "",
      linkType: optionValues["default.link-type"] ?? LinkType.LINK_TYPE_HYPERLINK,
      value: optionValues["default.href-option"] ?? "",
      openInNewTab: optionValues["default.open-in-new-tab"] ?? false,
      hasUpdated: false,
      page: "",
      pageSelectionType: PAGE_SELECTION_TYPE_NONE,
    };
  }

  static convertValueToStringForTransactionLog() {
    return "Updated href action";
  }
}
